import Header from "../components/Header";
import Hero from "../components/Hero";
import Vision from "../components/Vision";
import Categories from "../components/Categories";
import FeaturedProducts from "../components/FeaturedProducts";
import WhyUs from "../components/WhyUs";
import Contact from "../components/Contact";
import "../index.css";

function Home() {
  return (
    <>
      <Header />
      <Hero />
      <Vision />
      <Categories />
      <FeaturedProducts />
      <WhyUs />
      {/* <Testimonials /> */}
      <Contact />
    </>
  );
}

export default Home;
